import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { AskKnowledge } from "@/components/knowledge/AskKnowledge";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }) : "—");

export function MyRecruitingActivity() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/referral-partner/activities").then((r) => setD(r.data)).catch(() => setD({ items: [], counts: {} })); }, []);
  return (
    <div className="max-w-4xl" data-testid="rp-activity-page">
      <PageHeader title="Recruiter Activity" description="Calls, meetings, interviews, notes and follow-ups you've logged on your referrals." />
      <div className="flex flex-wrap gap-2 mb-4" data-testid="rp-activity-counts">
        {Object.entries(d?.counts || {}).map(([k, v]) => <span key={k} className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-700">{k}: <strong>{v}</strong></span>)}
      </div>
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm divide-y divide-slate-100">
        {(d?.items || []).length === 0 && <p className="p-5 text-sm text-slate-500" data-testid="rp-activity-empty">No activity yet. Open a referral to log a call, meeting or note.</p>}
        {(d?.items || []).map((a) => (
          <div key={a.id} className="p-3 text-sm flex flex-wrap gap-2" data-testid={`rp-activity-${a.id}`}>
            <span className="rounded bg-[#006090]/10 text-[#006090] px-2 py-0.5 text-xs">{a.type_label}</span>
            <Link to={`/referrals/${a.person_id}`} className="font-medium text-slate-800 hover:underline">{a.name}</Link>
            <span className="text-slate-600 flex-1 min-w-[200px]">{a.summary}</span>
            <span className="text-xs text-slate-400">{fmt(a.occurred_at)}{a.follow_up_date ? ` · follow up ${a.follow_up_date}` : ""}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PartnerKnowledge() {
  return (
    <div className="max-w-3xl" data-testid="rp-knowledge-page">
      <PageHeader title="Knowledge Center" description="Ask questions and get answers from resources approved for your role." />
      <AskKnowledge />
    </div>
  );
}

export default MyRecruitingActivity;
